import { getMarketCode } from '../domain/domainConstants';

export enum ThemeColorEnum {
  PRIMARY = '--theme-primary',
  LIGHT = '--theme-light',
  LIGHT_GRADIENT = '--theme-light-grad',
  SECONDARY = '--theme-secondary',
  GRAY_DISABLED = '--theme-gray-disabled',
  YELLOW_ENERGY = '--theme-yellow-energy',
  ERROR = '--theme-error',
  GREY1 = '--theme-grey-1',
  GREY2 = '--theme-grey-2',
  GREY3 = '--theme-grey-3',
  GREY4 = '--theme-grey-4',
  BLACK = '--theme-black',
  WHITE = '--theme-white',
  YELLOW_ALERT = '--theme-yellow-alert',
  PRIMARY_GRAD = '--theme-primary-grad',
  BRIGHT = '--theme-bright',
  PRIMARY_BTN = '--theme-primary-btn',
  PRIMARY_BTN_GRADIENT = '--theme-primary-gradient-btn',
}

export function getThemeColorVar(color: ThemeColorEnum): string {
  return `var(${color})`;
}


export function getImageByDomain(path: string , extension: string = 'png'){
  const domain = getMarketCode();
  if (!domain) {
    return `${path}-clc.${extension}`;
  }
  return `${path}-${domain.toLowerCase()}.${extension}`;
}


export function getThemeColor(color: ThemeColorEnum, defaultColor: string ): string {
  return getComputedStyle(document.documentElement).getPropertyValue(color).trim() || defaultColor;
}


